import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FloatInput, FloatSelect } from "src/componentes";
import {
  CTeDocumentoDto,
  CTeDto,
  getLocal,
  STORAGECTE_KEY,
  tipoDocumentoOptions,
  updateLocal,
} from "../CTe.Dto";
import { DocumentosFormType, DocumentosSchema } from "./CTe.Cadastro.Dto";

const CTeCadastroDocumentosView = () => {
  const navigate = useNavigate();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);
  const documentos = cte?.documentos;

  const form = useForm<DocumentosFormType>({
    resolver: yupResolver(DocumentosSchema),
    defaultValues: {
      documentos:
        documentos && documentos.length > 0
          ? documentos
          : [
              {
                tipoDocumento: 1,
                chaveDocumento: "",
              },
            ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "documentos",
  });

  const handleVoltar = () => {
    navigate("../valores");
  };

  const onSubmit = (data: DocumentosFormType) => {
    const docsDto: CTeDocumentoDto[] = (data.documentos || []).map((doc) => ({
      tipoDocumento: Number(doc.tipoDocumento),
      chaveDocumento: doc.chaveDocumento,
    }));

    updateLocal<CTeDto>(STORAGECTE_KEY, {
      documentos: docsDto,
    });

    navigate("../finalizacao");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="text-primary mb-0">Documentos Originários Transportados</h5>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() =>
            append({
              tipoDocumento: 1,
              chaveDocumento: "",
            })
          }
        >
          + Adicionar Documento
        </Button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong>Documento #{index + 1}</strong>
            {fields.length > 1 && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => remove(index)}
              >
                Remover
              </Button>
            )}
          </div>
          <Row className="g-3">
            <Col xs={12} md={4}>
              <FloatSelect
                label="Tipo de Documento"
                options={tipoDocumentoOptions}
                register={form.register(`documentos.${index}.tipoDocumento`, {
                  valueAsNumber: true,
                })}
                errorsMessage={
                  form.formState.errors.documentos?.[index]?.tipoDocumento
                }
              />
            </Col>
            <Col xs={12} md={8}>
              <FloatInput
                label="Chave de Acesso (44 dígitos)"
                registerField={form.register(`documentos.${index}.chaveDocumento`)}
                errorsMessage={
                  form.formState.errors.documentos?.[index]?.chaveDocumento
                }
                inputMask="int"
                maxLength={44}
              />
            </Col>
          </Row>
        </div>
      ))}

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="outline-primary" type="submit">
                Próximo
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroDocumentosView;
